import _slicedToArray from "/var/www/html/meameal/prod/front_meameal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useToken } from '../../theme/internal';

var useCSSVarCls = function useCSSVarCls(prefixCls) {
  var _useToken = useToken(),
      _useToken2 = _slicedToArray(_useToken, 5),
      cssVar = _useToken2[4];

  return cssVar ? "".concat(prefixCls, "-css-var") : '';
};

export default useCSSVarCls;